/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
import '../resources/credit_line_statement';
import '../../connect/v2/resources/error';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "corporate_card": {
        "nested": {
          "service": {
            "nested": {
              "SearchStatementsRequest": {
                "fields": {
                  "creditLineId": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "SearchStatementsResponse": {
                "fields": {
                  "creditLineStatements": {
                    "type": ".squareup.corporate_card.resources.CreditLineStatement",
                    "id": 1,
                    "rule": "repeated"
                  },
                  "errors": {
                    "type": ".squareup.connect.v2.resources.Error",
                    "id": 2,
                    "rule": "repeated"
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.corporate_card?.nested?.service?.nested?.SearchStatementsRequest && !$root.nested?.squareup?.nested?.corporate_card?.nested?.service?.nested?.SearchStatementsResponse) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE SearchStatementsRequest @ squareup/corporate_card/service/search_statements.proto at 9:1
 */
export const SearchStatementsRequest = $root.lookupType('squareup.corporate_card.service.SearchStatementsRequest');
fixType(SearchStatementsRequest);
Builder.createAndAttachToType(SearchStatementsRequest);
/**
 * SOURCE SearchStatementsResponse @ squareup/corporate_card/service/search_statements.proto at 17:1
 */
export const SearchStatementsResponse = $root.lookupType('squareup.corporate_card.service.SearchStatementsResponse');
fixType(SearchStatementsResponse);
Builder.createAndAttachToType(SearchStatementsResponse);